<div class="file-select">
    <div class="file-preview" (click)="onPreviewClicked()" *ngIf="inputShowPreview">
        <span *ngIf="isWebImage(value)" [style.background-image]="'url(' + value + ')'"></span>
        <span *ngIf="!isWebImage(value)">
            <span [class]="getIconClass(value)">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
                <span class="path4"></span>
                <span class="path5"></span>
                <span class="path6"></span>
            </span>
        </span>
    </div>
    <mat-form-field class="w-100" [placement]="inputTooltipPlacement" [tcTooltip]="inputTooltipText">
        <input
            #valueInput
            matInput
            [id]="_id"
            type="text"
            [(ngModel)]="value"
            [name]="inputName"
            (blur)="onBlur()"
            autocomplete="off"
            [disabled]="isDisabled"
            [pattern]="regex"
            readonly
            [placeholder]="inputName"
            [required]="inputIsRequired"
            (click)="valueInput.select()"
        />
        <terra-file-chooser
            matSuffix
            [inputIcon]="'icon-more'"
            [inputTooltipText]="_translationPrefix + '.chooseFile' | translate: _locale.language"
            [inputTooltipPlacement]="'left'"
            [inputAllowedExtensions]="inputAllowedExtensions"
            [inputAllowFolders]="inputAllowFolders"
            [inputStorageServices]="inputStorageServices"
            (outputSelected)="onObjectSelected($event)"
            (outputFileBrowserShow)="$event.selectUrl(value)"
        >
        </terra-file-chooser>
        <button
            matSuffix
            mat-icon-button
            [tcTooltip]="_translationPrefix + '.reset' | translate: _locale.language"
            [placement]="'left'"
            (click)="resetValue()"
        >
            <mat-icon>clear</mat-icon>
        </button>
    </mat-form-field>

    <ng-template let-data #imagePreviewDialog>
        <h2 mat-dialog-title>{{ data.filename }}</h2>
        <mat-dialog-content>
            <img [src]="data.filepath" />
        </mat-dialog-content>
    </ng-template>
</div>
